import { ESRI_DEFAULT_ICON_LABEL_FONT } from '../configurations';
import type { LabelClassProperties } from '../types';
import { colors } from '../../colors/colors';
import hospitalInactive from '../images/hospital-icons/hospital_inactive.svg';
import hospitalSelected from '../images/hospital-icons/hospital_selected.svg';

export const hospitalUniqueValueInfos = [
    {
        value: 'Inactive',
        symbol: {
            type: 'picture-marker',
            url: hospitalInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Selected',
        symbol: {
            type: 'picture-marker',
            url: hospitalSelected,
            width: '32px',
            height: '32px',
        },
    },
];

export const hospitalIconRenderer = {
    type: 'unique-value', // autocasts as new UniqueValueRenderer()
    field: 'iconName',
    defaultSymbol: {
        // used when item field dont match anything defined in uniqueValueInfos
        type: 'simple-marker',
        style: 'square',
        color: colors.mapLabelDefault,
        size: '32px',
    },
    uniqueValueInfos: [...hospitalUniqueValueInfos],
    authoringInfo: undefined,
};

const inactiveHospitalIconLabel: LabelClassProperties = {
    symbol: {
        type: 'text',
        color: colors.mapLabelText,
        haloColor: colors.mapLabelHalo,
        haloSize: '1px',
        xoffset: '-4px',
        font: ESRI_DEFAULT_ICON_LABEL_FONT,
    },
    labelPlacement: 'center-right',
    labelExpressionInfo: {
        expression: `$feature.hospitalName`,
    },
    maxScale: 0,
    minScale: 25000000,
    where: `uiState<>'Selected'`,
};

const selectedHospitalIconLabel: LabelClassProperties = {
    symbol: {
        type: 'text',
        color: colors.mapLabelAlert,
        haloColor: colors.mapLabelHalo,
        haloSize: '1px',
        xoffset: '-4px',
        font: ESRI_DEFAULT_ICON_LABEL_FONT,
    },
    labelPlacement: 'center-right',
    labelExpressionInfo: {
        expression: `$feature.hospitalName`,
    },
    maxScale: 0,
    minScale: 25000000,
    where: `uiState='Selected'`,
};

export const hospitalIconLabels = [inactiveHospitalIconLabel, selectedHospitalIconLabel];
